//import axios from 'axios'
import {CartItem} from './src/contexts/CartReducer'
import axios from '@/utils/axios'
const API = process.env.NEXT_PUBLIC_API_URL + '/cart' // your laravel route

const cart = {
  async addToCart(uuid: string, item: CartItem) {
    await axios.post(`${API}/${uuid}`, item)
  },

  async updateCartItem(uuid: string, item: CartItem) {
    await axios.put(`${API}/item/${uuid}/${item.uuid}`, item)
  },

  async linkUser(uuid: string) {
    await axios.get(`${API}/link-user/${uuid}`)
  },

  async removeCartItem(uuid: string, itemId: string) {
    await axios.delete(`${API}/item/${uuid}/${itemId}`)
  },

  async updateAddress(uuid: string, address: any) {
    await axios.put(`${API}/address/${uuid}`, address)
  },

  async updateAddressType(
    uuid: string,
    address_type: 'pickup_point' | 'home_delivery' | 'self_pickup',
  ) {
    await axios.put(`${API}/address-type/${uuid}`, {address_type})
  },

  async applyCoupon(uuid: string, coupon: string) {
    await axios.post(`${API}/coupon/${uuid}`, {coupon})
  },

  async removeCoupon(uuid: string) {
    await axios.delete(`${API}/coupon/${uuid}`)
  },

  async updateShipping(uuid: string, shipping_fee: number) {
    await axios.put(`${API}/${uuid}/shipping`, {shipping_fee})
  },

  async emptyCart(uuid: string) {
    await axios.delete(`${API}/${uuid}`)
  },

  async fetchCart(uuid: string) {
    const response = await axios.get(`${API}/${uuid}`)
    return response.data
  },
}

export default cart
